import api from '~/api'

const TYPES = Object.freeze({
});

const stateObject = {
  data: {
    current: '',
    is_home: '',
    is_archive: '',
    is_page: '',
    is_category: '',
    is_term: '',
    is_tag: '',
    is_single: '',
    is_404: '',
    the_id: '',
    meta: {
      title: '',
      ogp: {
        'description': '',
        'keyword': '',
        'og:description': '',
        'og:title': '',
        'og:image': '',
        'og:site_name': '',
        'og:url': '',
        'og:type': '',
        'twitter:title': '',
        'twitter:description': '',
        'twitter:url': '',
        'twitter:image': ''
      }
    }
  },
  state: {
    isLoading: 0,
    color: ''
  }
};

const getters = {
  getInfo: state => data => {
    return state.data;
  },
  getState: state => data => {
    return state.state;
  },
  getMeta: state => data => {
    // return state.data.meta;

    // const _defaultSet = Object.assign({}, state.data.meta.ogp);
    // const _updated = Object.assign(_defaultSet, data);
    let _result = [];

    // vue-head用の加工
    // Object.keys(state.data.meta.ogp).forEach(k => {
    //   var item = {};

    //   if(k.match(/^og:/) || k.match(/^fb:/)) {
    //     item['property'] = k;
    //   } else {
    //     item['name'] = k;
    //   }

    //   item['content'] = state.data.meta.ogp[k];
    //   item['id'] = k.replace(':', '-');

    //   _result.push(item);
    // });

    // vue-meta用の加工
    if(!state.data.meta.ogp) {
      return []
    }
    Object.keys(state.data.meta.ogp).forEach(k => {
      var item = {};

      if(k.match(/^og:/) || k.match(/^fb:/)) {
        item['property'] = k;
      } else {
        item['name'] = k;
      }
      item['vmid'] = k;
      item['content'] = state.data.meta.ogp[k];
      // item['id'] = k.replace(':', '-');

      _result.push(item);
    });

    return _result;
  }
};

const mutations = {
  SAVE_INFO(state, data) {
    state.data = Object.assign(state.data, data)
  },
  SAVE_COLOR(state, data) {
    state.state.color = data;
  },
  SAVE_LOADING(state, data) {
    state.state.isLoading = data;
  },
};

const actions = {
  async ['fetchInfo']({ commit, state }, slug) {
    commit('SAVE_LOADING', 1);

    const result = await api.fetchInfo(slug);
    commit('SAVE_LOADING', 0);
    commit('SAVE_INFO', result);
    // return Promise.resolve();
    return result
  },
};

export default {
  namespaced: true,
  state: stateObject,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/route.js